import React from "react";
import { Link } from "react-router-dom";

const AboutYarqinMirzad = () => {
  return (
    // Section Container: Slate-50 for contrast with previous white section
    <section className="py-24 bg-slate-50 overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 items-center gap-12 lg:gap-16">
          {/* --- Left Column: Image (Mobile: Top, Desktop: Left) --- */}
          <div className="relative group cursor-pointer">
            {/* Main Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border border-slate-200">
              <img
                src="https://images.unsplash.com/photo-1504384308090-c894fdcc538d?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.1.0"
                alt="Yarqin Mirzad Operations"
                className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700"
              />

              {/* Floating Badge: Established Year */}
              <div className="absolute top-6 left-6 bg-white/95 backdrop-blur-sm px-5 py-2 rounded-full shadow-lg border border-blue-100">
                <span className="text-xs font-bold text-blue-600 uppercase tracking-wider">
                  Since 2020
                </span>
              </div>
            </div>

            {/* Decorative blurred blob behind image */}
            <div className="absolute -bottom-6 -right-6 w-64 h-64 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-50 -z-10"></div>
          </div>

          {/* --- Right Column: Content (Mobile: Bottom, Desktop: Right) --- */}
          <div className="max-w-2xl mx-auto md:mx-0 text-center md:text-left">
            {/* Badge Title */}
            <span className="inline-block py-1 px-3 rounded-full bg-blue-50 text-blue-600 text-xs font-semibold tracking-wide uppercase mb-4">
              Parent Company
            </span>

            {/* Main Title */}
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 mb-6 tracking-tight">
              Background and Roots: <br />
              <span className="text-blue-600">Yarqin Mirzad</span>
            </h2>

            {/* Description with highlighted key metric */}
            <p className="px-5 text-lg text-slate-600 leading-relaxed mb-6 text-justify md:text-left">
              Yarqin Mirzad is an electronic and internet services company that
              began its operations in 2021. It currently provides services in
              over 20 locations across Afghanistan and plans to expand soon to
              Kabul, Herat, Kandahar, and Jalalabad. With its{" "}
              <span className="text-blue-600 font-bold">
                24-hour (99.9% uptime)
              </span>{" "}
              internet service and dedicated technical support, Yarqin Mirzad is
              recognized as one of Afghanistan’s leading technology companies.
            </p>

            <p className="px-5 text-lg text-slate-600 leading-relaxed mb-8 text-justify md:text-left">
              Yarqin Tech Hub was established as the accreditation and marketing
              branch of Yarqin Mirzad, serving as a bridge between Afghanistan’s
              technology companies and international systems of innovation,
              credibility, and trust.
            </p>

            {/* CTA Link */}
            {/* <div className="flex flex-col sm:flex-row gap-4 items-center justify-center md:justify-start">
              <Link
                to="/contact"
                className="group inline-flex items-center px-6 py-3 text-base font-semibold text-blue-600 transition-all hover:text-blue-800"
              >
                About Yarqin Mirzad
                <svg
                  className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M17 8l4 4m0 0l-4 4m4-4H3"
                  />
                </svg>
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutYarqinMirzad;
